<div class="supplier-selection-screen">
	<!-- HEADER -->
	<div class="ss-header">
		<div class="ss-header-left">
			<button type="button" class="ss-back-btn" (click)="goBack()">
				<i class="fas fa-arrow-left"></i>
			</button>

			<div class="ss-header-title-wrapper">
				<div class="ss-logo">
					<i class="fas fa-warehouse"></i>
				</div>
				<h1 class="ss-title">
					GOODS <span *ngIf="direction == 0">IN</span
					><span *ngIf="direction == 1">OUT</span> -
					{{this.renderMode(this.mode).toUpperCase()}}
				</h1>
			</div>
		</div>

		<div class="ss-clock">
			<span> {{ dateTime | date: 'EEE d MMM HH:mm' }} </span>
		</div>
	</div>

	<!-- MAIN -->
	<div class="ss-main">
		<div class="ss-main-inner">
			<!-- ACTION BUTTONS -->
			<div
				class="ss-actions"
				*ngIf="this.renderMode(this.mode).toUpperCase() !== 'OUTSIDE PROCESS' && this.renderMode(this.mode).toUpperCase() !== 'SUPPLIERS'"
			>
				<button
					type="button"
					class="ss-primary-action"
					(click)="goMoveStock()"
				>
					<i class="fas fa-box"></i>
					<span>PLACE STOCK</span>
				</button>

				<button
					type="button"
					class="ss-secondary-action"
					(click)="enterManual()"
				>
					<i class="fas fa-keyboard"></i>
					<span>ENTER MANUALLY</span>
				</button>
			</div>

			<!-- SEARCH -->
			<div
				class="ss-search-section"
				*ngIf="purchaseLogSuppliers && supplierSelected == false && this.renderMode(this.mode).toUpperCase() == 'PURCHASE'"
			>
				<div class="ss-search-wrapper">
					<input
						type="text"
						class="ss-search-input"
						placeholder="Search suppliers..."
						[(ngModel)]="supplierSearchTerm"
					/>
					<i class="fas fa-search ss-search-icon"></i>
				</div>
			</div>

			<div
				class="wo-search-section"
				*ngIf="this.renderMode(this.mode).toUpperCase() === 'OUTSIDE PROCESS' || this.renderMode(this.mode).toUpperCase() === 'SUPPLIERS'"
			>
				<div class="wo-search-wrapper">
					<input
						type="text"
						class="wo-search-input"
						placeholder="Search part numbers..."
						[(ngModel)]="woSearchTerm"
					/>
					<i class="fas fa-search wo-search-icon"></i>
				</div>
			</div>

			<!-- SUPPLIERS GRID -->
			<div
				class="ss-grid"
				*ngIf="purchaseLogSuppliers && supplierSelected == false"
			>
				<button
					type="button"
					class="ss-card"
					*ngFor="let supplier of filteredSuppliers"
					(click)="selectSupplier(supplier.id)"
				>
					<div class="ss-card-inner">
						<div class="ss-card-icon-wrapper">
							<img
								*ngIf="getSupplierLogoUrl(supplier.name) as logoUrl; else supplierFallbackIcon"
								[src]="logoUrl"
								[alt]="supplier.name"
								class="ss-card-icon-image"
								(error)="onSupplierLogoError(supplier)"
							/>
							<ng-template #supplierFallbackIcon>
								<i class="fas fa-truck"></i>
							</ng-template>
						</div>

						<div class="ss-card-text">
							<h3 class="ss-card-title">{{ supplier.name }}</h3>
						</div>
					</div>
				</button>
			</div>

			<!-- SUPPLIERS GRID -->
			<div
				class="ss-grid"
				*ngIf="purchaseLogs && supplierSelected == true"
			>
				<button
					type="button"
					class="ss-card"
					*ngFor="let log of purchaseLogs"
					(click)="goPurchaseDetail(log.id)"
				>
					<div class="ss-card-inner">
						<div class="ss-card-icon-wrapper">
							<h3 class="ss-card-title" style="color: white">
								{{log.id}}
							</h3>
						</div>
						<div class="ss-card-text">
							<h3 class="ss-card-title">
								Qty: {{ this.renderPlogLineItems(log.lineItems)
								}}
							</h3>
							<h3 class="ss-card-title">
								Due: {{ renderPlogDueDate(log.dueDate) }}
							</h3>
							<h3 class="ss-card-title">
								Type: {{ renderPlogType(log.purchaseType) }}
							</h3>
						</div>
					</div>
				</button>
			</div>

			<!-- OUTSOURCE GRID -->
			<div class="wo-main" *ngIf="machines.length > 0">
				<div class="wo-main-inner">
					<!-- GRID -->
					<div class="wo-grid">
						<button
							type="button"
							class="wo-card"
							*ngFor="let order of filteredStages"
							(click)="selectStage(order)"
						>
							<div class="wo-card-inner">
								<div class="wo-card-image-wrapper">
									<img
										[src]="order.partImage"
										[alt]="order.partNumber"
										class="wo-card-image"
									/>
								</div>

								<div class="wo-card-content">
									<div class="wo-card-header-row">
										<h3 class="wo-card-code">
											WO{{ order.workOrderId }}
										</h3>
										<span class="wo-op-badge"
											>{{ order.operationNumber }}</span
										>
									</div>

									<p class="wo-card-part">
										Part: {{ order.partNumber }}
									</p>
									<p class="wo-card-qty">
										{{ order.quantity }}
									</p>
									<p class="wo-card-due">
										Due: {{ order.dateRequired }}
									</p>
								</div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- ================= OUTSIDE RECEIVED MODAL (DROP-IN) ================= -->
	<div
		class="ss-modal-backdrop"
		*ngIf="showOutsideReceived"
		(click)="showOutsideReceived = false"
	></div>

	<div
		class="ss-modal"
		*ngIf="showOutsideReceived"
		role="dialog"
		aria-modal="true"
		aria-labelledby="outsideReceivedTitle"
	>
		<div class="ss-modal-card" (click)="$event.stopPropagation()">
			<h2 id="outsideReceivedTitle" class="ss-modal-title">
				Quantity Received
			</h2>

			<p class="ss-modal-subtitle">
				Enter the quantity received for this outside process.
			</p>

			<input
				type="number"
				class="ss-modal-input"
				placeholder="0"
				[(ngModel)]="quantityEntered"
				min="0"
				autofocus
			/>

			<div class="ss-modal-actions">
				<button
					type="button"
					class="ss-modal-cancel"
					(click)="showOutsideReceived = false"
				>
					Cancel
				</button>

				<button
					type="button"
					class="ss-modal-confirm"
					(click)="outsideReceived()"
					[disabled]="!quantityEntered || quantityEntered <= 0"
				>
					Confirm
				</button>
			</div>
		</div>
	</div>
	<!-- ================= END OUTSIDE RECEIVED MODAL ================= -->
	<!-- ================= OUTSIDE SENT MODAL (DROP-IN) ================= -->
	<div
		class="ss-modal-backdrop"
		*ngIf="showOutsideSent"
		(click)="showOutsideSent = false"
	></div>

	<div
		class="ss-modal"
		*ngIf="showOutsideSent"
		role="dialog"
		aria-modal="true"
		aria-labelledby="outsideSentTitle"
	>
		<div class="ss-modal-card" (click)="$event.stopPropagation()">
			<h2 id="outsideSentTitle" class="ss-modal-title">
				Confirm Dispatch
			</h2>

			<p class="ss-modal-subtitle">
				Are you sure you want to mark this part/work order as
				dispatched?
			</p>

			<div class="ss-modal-actions">
				<button
					type="button"
					class="ss-modal-cancel"
					(click)="showOutsideSent = false"
				>
					Cancel
				</button>

				<button
					type="button"
					class="ss-modal-confirm"
					(click)="outsideSent()"
				>
					Confirm
				</button>
			</div>
		</div>
	</div>
	<!-- ================= END OUTSIDE SENT MODAL ================= -->
</div>
